import { Stack, Link } from "expo-router";
import { ScrollView, StyleSheet, View } from "react-native";
import { Text } from "react-native-paper";

const supportEmail = "info@upsee.jp";

const sections = [
  {
    title: "アプリ内で削除する方法",
    body: [
      "学問レンズにログインします。",
      "プロフィール画面を開きます。",
      "アカウント管理の「アカウント削除」を選択します。",
      "確認内容に同意して、削除を実行します。",
    ],
  },
  {
    title: "アプリを利用できない場合",
    body: [
      `登録メールアドレスから ${supportEmail} 宛にご連絡ください。`,
      "件名は「学問レンズ アカウント削除依頼」としてください。",
      "本文に、登録メールアドレスと削除を希望する旨を記載してください。",
    ],
  },
  {
    title: "削除されるデータ",
    body: [
      "アカウント情報、プロフィール情報",
      "投稿、学習メモ、コメント、リアクション、通報内容",
      "プロフィール画像、投稿に添付した画像など、アカウントに関連する保存データ",
    ],
  },
  {
    title: "保持される場合がある情報",
    body: [
      "法令遵守、不正利用防止、セキュリティ対応のために必要な最小限の記録は、合理的な期間保持される場合があります。",
      "削除手続きでは、本人確認のために追加情報をお願いする場合があります。",
    ],
  },
];

export default function DeleteAccountPage() {
  return (
    <>
      <Stack.Screen options={{ title: "アカウントとデータの削除" }} />
      <ScrollView style={styles.page} contentContainerStyle={styles.content}>
        <View style={styles.header}>
          <Text style={styles.kicker}>学問レンズ</Text>
          <Text style={styles.title}>アカウントとデータの削除</Text>
          <Text style={styles.updated}>最終更新日: 2026年6月16日</Text>
          <Text style={styles.lead}>
            学問レンズでは、ユーザーがアカウントと関連データの削除をリクエストできます。
            アプリ内の削除機能、またはメールで削除を依頼できます。
          </Text>
        </View>

        <View style={styles.policy}>
          {sections.map((section, index) => (
            <View key={section.title} style={styles.section}>
              <Text style={styles.sectionTitle}>
                {index + 1}. {section.title}
              </Text>
              {section.body.map((item) => (
                <Text key={item} style={styles.paragraph}>
                  {item}
                </Text>
              ))}
            </View>
          ))}

          <View style={styles.section}>
            <Text style={styles.sectionTitle}>5. お問い合わせ</Text>
            <Text style={styles.paragraph}>
              アカウント削除、データ削除、個人情報の取り扱いに関するお問い合わせは、
              {supportEmail} までご連絡ください。
            </Text>
          </View>
        </View>

        <View style={styles.footer}>
          <Link href={"/privacy" as never} style={styles.link}>
            プライバシーポリシー
          </Link>
          <Link href={"/marketing" as never} style={styles.link}>
            学問レンズについて
          </Link>
          <Text style={styles.footerText}>© 2026 Upsee Inc. 学問レンズ</Text>
        </View>
      </ScrollView>
    </>
  );
}

const styles = StyleSheet.create({
  page: {
    flex: 1,
    backgroundColor: "#f8fafc",
  },
  content: {
    alignItems: "center",
    paddingBottom: 44,
  },
  header: {
    width: "100%",
    maxWidth: 860,
    paddingHorizontal: 24,
    paddingTop: 56,
    paddingBottom: 28,
  },
  kicker: {
    color: "#116466",
    fontSize: 16,
    fontWeight: "800",
    marginBottom: 10,
  },
  title: {
    color: "#111827",
    fontSize: 36,
    lineHeight: 46,
    fontWeight: "800",
    marginBottom: 10,
  },
  updated: {
    color: "#6b7280",
    fontSize: 14,
    marginBottom: 18,
  },
  lead: {
    color: "#4b5563",
    fontSize: 16,
    lineHeight: 28,
  },
  policy: {
    width: "100%",
    maxWidth: 860,
    paddingHorizontal: 24,
  },
  section: {
    borderTopWidth: 1,
    borderTopColor: "#dfe7ef",
    paddingVertical: 22,
  },
  sectionTitle: {
    color: "#111827",
    fontSize: 20,
    fontWeight: "800",
    marginBottom: 10,
  },
  paragraph: {
    color: "#374151",
    fontSize: 15,
    lineHeight: 26,
    marginBottom: 8,
  },
  footer: {
    width: "100%",
    maxWidth: 860,
    paddingHorizontal: 24,
    paddingTop: 12,
    gap: 12,
  },
  link: {
    color: "#116466",
    fontWeight: "800",
  },
  footerText: {
    color: "#6b7280",
    fontSize: 13,
  },
});
